import "nette.ajax.js";

$.nette.ext({
	load: function () {
		$('[data-confirm-text]').click(function (event) {
			var obj = this;
			event.preventDefault();
			event.stopImmediatePropagation();
			$("<div id='dialog-confirm-modal' class='modal fade'><div class='modal-dialog modal-dialog-centered'><div id='dialog-confirm' class='modal-content'></div></div></div>").appendTo('body');
			$('#dialog-confirm').html("<div id='dialog-confirm-header' class='modal-header justify-content-center border-0'></div><div id='dialog-confirm-body' class='modal-body text-center fs-1'></div><div id='dialog-confirm-footer' class='modal-footer justify-content-center border-0'></div>");
			$('#dialog-confirm-header').html("<h5 class='modal-title' id='dialog-confirm-title'></h5>");
			$('#dialog-confirm-title').html($(obj).data('confirm-title') || "Potvrzení akce");
			$('#dialog-confirm-body').html($(obj).data('confirm-text') || "Opravdu chcete akci provést?");
			$('#dialog-confirm-footer').html("<a href='#' id='dialog-confirm-ok' class='btn " + ($(obj).data('confirm-ok-class') || "btn-danger") + "' data-dismiss='modal'>Ano</a><a href='#' id='dialog-confirm-cancel' class='btn btn-light bg-white' data-dismiss='modal'>Ne</a>");
			if ($(obj).data('confirm-header-class')) {
				$('#dialog-confirm-header').addClass($(obj).data('confirm-header-class'));
			}
			if ($(obj).data('confirm-ok-text')) {
				$('#dialog-confirm-ok').html($(obj).data('confirm-ok-text'));
			}
			if ($(obj).data('confirm-cancel-text')) {
				$('#dialog-confirm-cancel').html($(obj).data('confirm-cancel-text'));
			}
			$('#dialog-confirm-ok').on('click', function () {
				var tagName = $(obj).prop("tagName");
				if (tagName == 'INPUT') {
					var form = $(obj).closest('form');
					form.submit();
				} else {
					if ($(obj).data('ajax') == 'on') {
						$.nette.ajax({
							url: obj.href
						});
					} else {
						document.location = obj.href;
					}
				}
			});
			$('#dialog-confirm-modal').on('hidden', function () {
				$('#dialog-confirm-modal').remove();
			});
			$('#dialog-confirm-modal').modal('show');
			return false;
		});
	}
});
